import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo Xero connector (Komodo.SCM.Web/Controllers/Xero/*). Some routes are PascalCase.
const enc = encodeURIComponent;

const instances = () => Client.get('/api/xero-instance');
const createInstance = (dto) => Client.post('/api/xero-instance', dto);
const updateInstance = (code, dto) =>
	Client.put(`/api/xero-instance/${enc(code)}`, dto);
// → BooleanResult
const unbind = (dto) => Client.post('/api/xero-instance/xero-unbind', dto);
const bindTenant = (dto) =>
	Client.post('/api/xero-instance/xero-bind-teant', dto);
// XeroOauthReq { code, redirectUri } → XeroConnectionDTO[]
const connections = (instanceCode, code, redirectUri) =>
	Client.post(
		`/api/xero-instance/xero-connections/${enc(instanceCode)}/query-list`,
		{ code, redirectUri }
	);
const webhookUrl = (deptCode) =>
	Client.get(`/api/xero-instance/xero-webhooks/${enc(deptCode)}`);
// Portal-specific: OAuth constants + redirect URI (added in feature/portal-config).
const oauthSetting = () => Client.get('/api/xero-instance/oauth-setting');
const OPERATIONS = {
	0: 'PullXeroAccounts',
	1: 'InitXeroCustomer',
	2: 'RebindXeroAccount',
};
const operation = (type, dto) =>
	Client.post(`/api/xero-instance/${OPERATIONS[type]}`, dto);

const accountings = () => Client.get('/api/xero-accounting');
const accountingPager = (query) =>
	Client.post('/api/xero-accounting/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
const createAccounting = (dto) => Client.post('/api/xero-accounting', dto);
const updateAccounting = (id, dto) =>
	Client.put(`/api/xero-accounting/${enc(id)}`, dto);

const relationPager = (query) =>
	Client.post('/api/xero-accounting-relation/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
const saveRelation = (dto) =>
	Client.put(`/api/xero-accounting-relation/${enc(dto.accountingCode)}`, dto);

const optionRecords = (query) =>
	Client.post('/api/xero-option/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);
// Re-queues the record as a new one → CommonActionResult
const retryOption = (dto) => Client.post('/api/xero-option', dto);

export default {
	instances,
	createInstance,
	updateInstance,
	unbind,
	bindTenant,
	connections,
	webhookUrl,
	oauthSetting,
	operation,
	accountings,
	accountingPager,
	createAccounting,
	updateAccounting,
	relationPager,
	saveRelation,
	optionRecords,
	retryOption,
};
